
import {
  GET_ONE_DEMO_TRIP
} from '../../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../../utils/status';

const INIT_STATE = {
  data: undefined,
  status: undefined
};


export default function reducer(state = INIT_STATE, action) {
  let nextState;

  if (action.type === GET_ONE_DEMO_TRIP) {
    switch (action.status) {
      case PENDING:
      case FAILURE:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case SUCCESS:
        // 如果接口傻逼，或返回null
        let trip = action.data || {};
        nextState = {
          ...state,
          data: trip.trip_id,
          status: action.status
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}




// WEBPACK FOOTER //
// ./src/store/reducers/trip/demo.js